import clsx from "clsx";
import { useState } from "react";

import { ChoiceCard, FunnelScreen, PrimaryButton } from "../screen";

import type { ScreenProps } from "../types";

// A column of cards, for the three questions shaped that way: the company
// someone works for, the kinds they work with, and their role at it. Which words
// each uses is funnel.ts's business; all this renderer reads off the step is
// whether more than one answer is allowed.
//
// One pick is the answer, so a single-pick advances on the click. A multi has
// nothing to advance on, so a Continue appears once there is something to
// continue with.
export default function ChoiceCardsStep({
  step,
  answer,
  busy,
  save,
  back,
}: ScreenProps) {
  const multi = step.multi ?? false;
  const [picked, setPicked] = useState<string[]>(() => [
    ...(answer?.values ?? []),
  ]);

  const choose = (id: string) => {
    if (busy) return;
    if (!multi) {
      save({ values: [id] });
      return;
    }
    setPicked((current) =>
      current.includes(id)
        ? current.filter((value) => value !== id)
        : [...current, id]
    );
  };

  // An odd number of cards leaves a hole in a two-column grid; the last one
  // fills it rather than sitting beside one.
  const options = step.options ?? [];
  const odd = options.length % 2 === 1;

  return (
    <FunnelScreen back={back} title={step.title}>
      <div className="mt-6 grid grid-cols-2 gap-3">
        {options.map((option, index) => (
          <ChoiceCard
            key={option.id}
            label={option.name}
            selected={multi && picked.includes(option.id)}
            className={clsx(
              odd && index === options.length - 1 && "col-span-2"
            )}
            onClick={() => choose(option.id)}
          />
        ))}
      </div>

      {multi && picked.length > 0 && (
        <div className="mt-5">
          <PrimaryButton
            disabled={busy}
            onClick={() => save({ values: picked })}
          >
            Continue
          </PrimaryButton>
        </div>
      )}
    </FunnelScreen>
  );
}
